export const TAGS = {
  USER_ACCOUNT_LIST: 'accountList',
  USER_AVAILABLE_ACCOUNTS_LIST: 'availableAccountList',
  USER_LIST: 'userList',
};
